// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/localization/stylesheet/localization.style.scss
 ** module id = 413
 ** module chunks = 1
 **/